// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Platform_FranchisesListInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /platform/v1/franchises — the resource's `list_filters`
 * (contracts/platform/resources/franchise.yml). Both optional; any other query key is
 * refused (`filtro_invalido:<chave>`, 400), never silently ignored.
 */
import { registerContract } from './validate'

export interface Platform_FranchisesListInput {
status?: string
country?: string
}

registerContract('Platform_FranchisesListInput', {
  status:  { type: 'string',  required: false },
  country: { type: 'string',  required: false },
})
